import { render, staticRenderFns } from "./upload-attachment-action.vue?vue&type=template&id=a57bec40"
import script from "./upload-attachment-action.ts?vue&type=script&lang=js&external"
export * from "./upload-attachment-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports